import type { IPathBaseParam } from "./path";
import type { IUserRegisterDto } from "./types";

import type { IUsersResponse } from "@api/users/types";
import type { IApiResponse } from "@/api";
import { createPostApi } from "@api/util/createPostApi";

const postApis = createPostApi<
  IApiResponse<IUsersResponse>,
  IPathBaseParam,
  IUserRegisterDto
>("users.register");

export const register = {
  ...postApis,
};
